import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Taxonomy as TaxonomyTerm,
} from '@uncinc/react-drupal-core';

const ViewLatestThemes = ({ entities }) => (
  <div className="ViewLatestThemes">
    <Container>
      <div className="row">
        {entities.map((entity, index) => {
          const id = entity.getIn(['nid', 0, 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          return (
            <div key={uuid} className="col-sm-12 col-md-6">
              <TaxonomyTerm
                id={id}
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </div>
    </Container>
  </div>
);

export default ViewLatestThemes;
